import {
  ADD_AWARD_NOMINATION_SUCCESS,
  CREATE_ORDER_AWARD_NOMINATION_SUCCESS,
  GET_AWARD_DETAILS_SUCCESS,
  GET_AWARD_DETAILS_RESET,
  GET_AWARDS_LIST_SUCCESS,
  GET_AWARDS_CATEGORY_LIST_SUCCESS,
  GET_NOMINATION_DETAILS_SUCCESS,
  GET_NOMINATION_LIST_SUCCESS,
  RESET_AWARD_BILLING,
  ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS,
} from "../../redux/types/awards"

const initialState = {
  // USERS
  awardDetails: null,
  nominationOrderDetails: null,
  nominationFormDetails: null,
  encAwardNominationId: "",

  //ADMIN
  awardsList: [],
  nominationList: [],
  nominationDetails: null,
  awardCategoryList: [],
}

const awardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AWARD_DETAILS_SUCCESS:
      return {
        ...state,
        awardDetails: action.payload.details,
      }
    case GET_AWARD_DETAILS_RESET:
      return {
        ...state,
        awardDetails: null,
      }
    case ADD_AWARD_NOMINATION_SUCCESS:
      return {
        ...state,
        nominationFormDetails: action.payload.details,
        encAwardNominationId: action.payload.enc_award_nomination_id,
      }
    case CREATE_ORDER_AWARD_NOMINATION_SUCCESS:
      return {
        ...state,
        nominationOrderDetails: action.payload.data,
      }
    case GET_AWARDS_LIST_SUCCESS:
      return {
        ...state,
        awardsList: action.payload.data,
      }
    case GET_NOMINATION_LIST_SUCCESS:
      return {
        ...state,
        nominationList: action.payload.data,
      }
    case GET_NOMINATION_DETAILS_SUCCESS:
      return {
        ...state,
        nominationDetails: action.payload.data,
      }
    case GET_AWARDS_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        awardCategoryList: action.payload.data,
      }
    case ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS:
      return {
        ...state,
        awardDetails: action.payload.details,
        encAwardNominationId: action.payload.enc_award_nomination_id,
      }
    case RESET_AWARD_BILLING:
      return {
        ...state,
        nominationOrderDetails: null,
      }
    default:
      return state
  }
}

export default awardsReducer
